import { EntityConfig } from 'angular-odata';

//#region ODataApi Imports
import { Attribute } from './attribute.entity';
//#endregion

export const AttributeConfig = {
  name: "Attribute",
  annotations: [],
  fields: {
    name: {type: 'Edm.String'},
    description: {type: 'Edm.String'},
    label: {type: 'Edm.String'},
    isIdea: {type: 'Edm.String'},
    example: {type: 'Edm.String'},
    statusId: {type: 'Edm.Int32'},
    statusTypeId: {type: 'Edm.Int32'},
    statusAt: {type: 'Edm.DateTimeOffset'},
    statusBy: {type: 'Edm.String'},
    createdBy: {type: 'Edm.String'},
    id: {type: 'Edm.Int32', key: true, ref: 'id', nullable: false},
    groupAttributes: {type: 'entities.schema.GroupAttribute', collection: true, navigation: true},
    maingroupAttributes: {type: 'entities.schema.MaingroupAttribute', collection: true, navigation: true},
    groupTreeAttributes: {type: 'entities.schema.GroupTreeAttribute', collection: true, navigation: true},
    artikelAttributes: {type: 'entities.articles.ArtikelAttribute', collection: true, navigation: true},
    produktTypAttributes: {type: 'entities.produkte.ProduktTypAttribute', collection: true, navigation: true},
    status: {type: 'entities.settings.Status', navigation: true, field: 'statusId', ref: 'id'},
    statusType: {type: 'entities.settings.StatusType', navigation: true, field: 'statusTypeId', ref: 'id'}
  }
} as EntityConfig<Attribute>;